// extracted by mini-css-extract-plugin
module.exports = {"priceContainer":"HRConsultationCreateDialog_priceContainer_3Ip6q","title":"HRConsultationCreateDialog_title_3PB4v"};